module.exports = __webpack_public_path__ + "img/40-image-1-1@2x.d2a4a903.png";